import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from "rxjs";
import { CoverageModel } from '../models/coverage.model';
import { InfraService } from './infra.service';

@Injectable({
  providedIn: 'root'
})
export class CoverageService {
  private coreAPIUrl: string;

  constructor(private infraService:InfraService, private http: HttpClient) {
    this.infraService.infraDetails$.subscribe(data => {
      this.coreAPIUrl = data.WebEndPoint2 + 'Coverage';
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }

    // if (localStorage.getItem('selectedregion') == '1') {
    //   this.configUrl = environment.apiUrl + 'coverage';

    // }
    // else {
    //   this.configUrl = environment.apiUrlRow + 'coverage';

    // }
  }

  public getAllCoverages(): Observable<CoverageModel[]> {
    return this.http.get<CoverageModel[]>(`${this.coreAPIUrl}/GetAllCoverages`);
    // .catch(this.handleError);
  }

  private handleError(error: Response) {
    return throwError(()=> error);
  }
}
